export default __webpack_public_path__ + "static/media/ic-crops-redonion.e888cffc.svg";